var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRingAlt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1625 7.55572C15.1055 6.66685 16 5.53858 16 4.45679C16 2.03402 13.7999 1.12947 12 3.00105C10.2001 1.12947 8 2.03402 8 4.45681C8 5.53857 8.89452 6.66684 9.83753 7.55572C6.60965 8.49175 4.25 11.4703 4.25 15C4.25 19.2802 7.71979 22.75 12 22.75C16.2802 22.75 19.75 19.2802 19.75 15C19.75 11.4703 17.3904 8.49176 14.1625 7.55572ZM5.75 15C5.75 11.5482 8.54822 8.75 12 8.75C15.4518 8.75 18.25 11.5482 18.25 15C18.25 18.4518 15.4518 21.25 12 21.25C8.54822 21.25 5.75 18.4518 5.75 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingAlt3);
export default __webpack_public_path__ + "static/media/ring-alt-3.d43ede8542f8200c80f61f0dce92d4a7.svg";
export { ForwardRef as ReactComponent };